









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BotonLinkMenu from './BotonLinkMenu.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { eventBus, filtroHomeEventBus, filtroHomeEvents } from '@/setup';
import config from '@/config';
import { watch } from 'fs';
import { LoadingService } from '@/services/loadingService';

@Component({
  components: {
    'btn-linked': BotonLinkMenu,
  },
})
export default class PanelInfo extends Vue {
  @Prop({ default: true }) show!: boolean;
  @Prop({ default: '' }) titulo!: string;
  @Prop({ default: '' }) texto!: string;
  appNames: any = this.$store.getters.getApplicationNames;
  appsLoaded: boolean = false;
  loadingService = new LoadingService();

  map: google.maps.Map;
  infoWindow = new google.maps.InfoWindow({
    content: '',
    disableAutoPan: true,
  });
  locations: any = [];
  labels: any = [];

  constructor() {
    super();
  }

  async mounted() {
    this.loadwidgets();
  }

  async created() {
    this.appNames = this.$store.getters.getApplicationNames;
    filtroHomeEventBus.$on('clienteMultiApp', (cliente: number) => {
      this.loadwidgets();
    });
  }

  loadwidgets() {
    let myInterval = setInterval(() => {
      if (this.$store.getters.getApplicationNames !== undefined) {
        this.appNames = this.$store.getters.getApplicationNames;
        this.appsLoaded = true;
        clearInterval(myInterval);
      }
    }, 1000);
  }

  get valideSubDomain(): boolean {
    let url: string = window.location.href;
    // Utilizamos una expresión regular para extraer el subdominio de la URL
    var subdominio = url.match(/^(?:https?:\/\/)?([^/.]+)/i);

    // Si se encontró un subdominio, lo retornamos
    if (subdominio && subdominio.length > 1) {
      switch (
        subdominio[1]
          .split(':')[0]
          .toString()
          .toLowerCase()
      ) {
        case 'gpstrack':
          return true;
        case 'track3':
          return true;
        case 'qagpstrack':
          return true;
          case 'localhost':
          return true;
        default:
          return false;
      }
    } else {
      return true; // No se encontró un subdominio
    }
  }
}
